<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="text-h6 primary white--text"> Selecione as turmas </v-card-title>
        <e-autocomplete
          :id="`modal_boletins.select_turmas_boletins_escola_${franquia_id}`"
          class="px-3 my-5"
          :items="turmasList"
          item-text="descricao"
          item-value="id"
          multiple
          return-object
          label="Selecione uma ou mais turmas"
          v-model="turmasSelecionadas"
        >
          <template v-slot:item="data">
            <v-list-item
              v-bind="data.attrs"
              v-on="data.on"
              :id="`modal_boletins.turma_${data.item.id}_escola_${franquia_id}`"
            >
              <v-list-item-content>
                <v-list-item-title>{{ data.item.descricao }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </e-autocomplete>

        <div v-if="turmasSelecionadas.length > 0" class="px-3 mb-3">
          <v-chip small color="primary" class="mb-2">
            {{ turmasSelecionadas.length }} turma{{
              turmasSelecionadas.length > 1 ? "s" : ""
            }}
            selecionada{{ turmasSelecionadas.length > 1 ? "s" : "" }}
          </v-chip>

          <v-alert v-if="turmasSelecionadas.length > 5" type="warning" dense outlined class="mb-2">
            <v-icon small class="mr-2">mdi-clock-alert</v-icon>
            Atenção: A geração do documento com mais de 5 turmas pode demorar mais tempo.
          </v-alert>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="modal_boletins.btn_fechar"
            color="primary"
            text
            @click="$emit('dialogChange', false)"
          >
            Fechar
          </v-btn>
          <v-btn
            id="modal_boletins.btn_confirmar"
            color="primary"
            text
            @click="gerarRelatorio"
            :disabled="turmasSelecionadas.length === 0"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    franquia_id: {
      type: Number,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      turmasList: [],
      turmasSelecionadas: [],
      dialogConfirmacao: false,
    };
  },
  watch: {
    dialog: {
      async handler(newVal) {
        if (newVal) {
          await this.listarTurmasFranquiaSelect(this.franquia_id);
        }
      },
    },
  },
  methods: {
    async listarTurmasFranquiaSelect(franquia) {
      this.carregandoTurmas = true;
      try {
        const response = await this.$services.turmasService.listarTurmasFranquia({
          franquia_id: franquia,
        });
        this.turmasList = response;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregandoTurmas = false;
      }
    },
    async confirmarSelecao() {
      if (this.turmasSelecionadas.length === 0) {
        this.$toast.danger("Selecione pelo menos uma turma.");
        return;
      }
      if (this.turmasSelecionadas.length > 5) {
        this.dialogConfirmacao = true;
      } else {
        this.gerarRelatorio();
      }
    },
    async gerarRelatorio() {
      this.dialogConfirmacao = false;
      this.$loaderService.open("Carregando dados...");
      try {
        await this.$services.relatoriosService.boletinsFranquia(
          this.franquia_id,
          this.turmasSelecionadas.map((turma) => turma.id)
        );
        this.turmasSelecionadas = [];
        this.$emit("dialogChange", false);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* Estilo personalizado, se necessário */
</style>
